export function listfilter() {
  const selectFilter = $('.linklist-filter select');

  const data = {
    'action': 'getLinkListFilter',
    'term_id': 0,
    'sort_id': 0,
  };

  const filter = (ele) => {
    $.ajax({
      type: 'POST',
      url: sanacorp.ajax_url,
      data: data,
      dataType: 'json',
      success: function(res) {
        const ajaxList = $(ele).parents('.linklist-filter').find('#ajaxList');
        ajaxList.empty();
        ajaxList.append(res['content']);
      },
      error: function (request, status, error) {
        console.log(request);
        console.log(status);
        console.log(error);
      },
    });
  }

  selectFilter.prop('selectedIndex',0);

  $(document).on('change', '.linklist-filter select', function () {
    if ($(this).attr('name') == 'sort') {
      data.sort_id = $(this).val();
    } else {
      data.term_id = $(this).val();
    }

    filter(this);
  });

  $('.linklist-filter').on('click', '.resetFilter', function(e) {
    e.preventDefault();
    $('select[name="filter"]').prop('selectedIndex',0).trigger('change');
  });
}



// WEBPACK FOOTER //
// ./scripts/components/listfilter.js